export const DEFAULT_TABLES = Object.freeze({
  default_data: Object.freeze({
    key: 'default_data',
    label: 'Default Data',
    columns: Object.freeze(['userUid', 'sessionId', 'conversationId', 'channel', 'messageCount', 'flowId', 'owner', 'status', 'lastActivityAt']),
    searchable: Object.freeze(['userUid', 'sessionId', 'conversationId', 'displayName']),
    sortable: Object.freeze(['lastActivityAt', 'messageCount']),
    filters: Object.freeze(['channel', 'status', 'owner', 'conditions']),
    exportPolicy: 'existing-platform-data-policy',
    access: 'existing-platform-data-api',
    readOnly: true,
  }),
  notifications: Object.freeze({
    key: 'notifications',
    label: 'Notifications',
    columns: Object.freeze(['recipient', 'sender', 'templateName', 'category', 'status', 'sentAt', 'deliveredAt', 'source', 'actions']),
    searchable: Object.freeze(['recipient', 'templateName', 'id']),
    sortable: Object.freeze(['createdAt']),
    filters: Object.freeze(['status', 'category', 'sender', 'recipient', 'templateName', 'source', 'apiKeyName', 'from', 'to']),
    exportPolicy: 'existing-campaign-hub-policy',
    access: 'existing-campaign-hub-api',
    readOnly: true,
  }),
});

export const DEFAULT_TABLE_LAYOUT_CONFIG = Object.freeze({ density: 'compact', stickyHeader: true, showRecordCount: true, pagination: true, readOnly: true });
